import React, {useState} from "react";
import {getVehicleMakeData} from "../../../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import { Box, Table, Title } from "@allxsmith/bestax-bulma";
import NewVehicleMake from "./NewVehicleMake";
import VehicleMakeRow from "./VehicleMakeRow";
import {createSetVehicleMakeDataAction} from "../../../../actions/dataActions";


export default function VehicleMake(props){
    const [page, setPage] = useState(1)
    const dispatch = useDispatch();
    let params = {page: page}
    const data = useSelector(getVehicleMakeData)

    const onVehicleMakeUpdate = (index, newVehicleMake) => {
        let newResults = [...data.results]
        let newState = {...data, results: newResults};
        newState.results[index] = newVehicleMake;
        dispatch(createSetVehicleMakeDataAction(newState))
    }

    return (
        <div>
            <NewVehicleMake />
            <Box>
                <details>
                    <summary><Title>Vehicle Make</Title></summary>
                    <Title size="6">Note: Changing these will affect all vehicles of that make</Title>
                    <Table
                        isFullwidth
                    >
                        <thead>
                        <tr>
                            <th>Make</th>
                            <th>Maintenance Cost Per Mile (£)</th>
                            <th>Additional Depreciation per Mile (£)</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.results.map((make, index) => (
                              <VehicleMakeRow
                                makeData={make}
                                index={index}
                                onUpdate={onVehicleMakeUpdate}
                                dataFresh={props.dataFresh}
                              />
                            ))}
                        </tbody>
                    </Table>
                </details>
            </Box>
        </div>
    );






}